import { FrontendLocale, dateFnsLocaleMap } from "@libry-content/localization";
import format from "date-fns/format";

export const formatSommerlesDate = (code: FrontendLocale, dateString: string): string =>
  format(new Date(`${new Date().getFullYear()}-${dateString}`), "d. MMMM", {
    locale: dateFnsLocaleMap[code],
  });
